module.exports = __webpack_public_path__ + "img/astarworld_prod.a9c28355.png";